import React from 'react';
import '../template-file-css/document-file-template.css';


export const CS_JobTrackingSheet = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='CS_JobTrackingSheet' className='file-pdf-document'>
            <div className='file-template'>



                <h2><b><center>Job Tracking Sheet</center></b></h2>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name: </span> </td>
                        <td className='w-375'> <span className='eleHeader'>MONTH/YEAR:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtName' name='txtName' className='add-only' /> </td>
                        <td className='w-375'><input type='text' id='txtMONTH' name='txtMONTH' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_1' name='txtCompany_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_1' name='txtPosition_1' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_1' name='txtStreetandCity_1' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_1' name='txtContectPerson_1' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_1' name='txtDateApplied_1' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_1' name='txtNotes_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_2' name='txtCompany_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_2' name='txtPosition_2' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_2' name='txtStreetandCity_2' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_2' name='txtContectPerson_2' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_2' name='txtDateApplied_2' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_2' name='txtNotes_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>3. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_3' name='txtCompany_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_3' name='txtPosition_3' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_3' name='txtStreetandCity_3' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_3' name='txtPhoneNumber_3' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_3' name='txtContectPerson_3' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_3' name='txtDateApplied_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_3' name='txtNotes_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>4. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_4' name='txtCompany_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_4' name='txtPosition_4' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_4' name='txtStreetandCity_4' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_4' name='txtPhoneNumber_4' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_4' name='txtContectPerson_4' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_4' name='txtDateApplied_4' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_4' name='txtNotes_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>5. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_5' name='txtCompany_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_5' name='txtPosition_5' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_5' name='txtStreetandCity_5' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_5' name='txtPhoneNumber_5' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_5' name='txtContectPerson_5' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_5' name='txtDateApplied_5' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_5' name='txtNotes_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>6. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_6' name='txtCompany_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_6' name='txtPosition_6' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_6' name='txtStreetandCity_6' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_6' name='txtPhoneNumber_6' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_6' name='txttxtContectPerson_6ontectPerson_4' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_6' name='txtDateApplied_6' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_6' name='txtNotes_6' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>7. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_7' name='txtCompany_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_7' name='txtPosition_7' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_7' name='txtStreetandCity_7' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_7' name='txtPhoneNumber_7' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_7' name='txtContectPerson_7' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_7' name='txtDateApplied_7' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_7' name='txtNotes_7' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>8. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_8' name='txtCompany_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_8' name='txtPosition_8' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_8' name='txtStreetandCity_8' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_8' name='txtPhoneNumber_8' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_8' name='txtContectPerson_8' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_8' name='txtDateApplied_8' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_8' name='txtNotes_8' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>9. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_9' name='txtCompany_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_9' name='txtPosition_9' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_9' name='txtStreetandCity_9' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_9' name='txtPhoneNumber_9' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_9' name='txtContectPerson_9' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_9' name='txtDateApplied_9' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_9' name='txtNotes_9' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>10. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_10' name='txtCompany_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_10' name='txtPosition_10' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_10' name='txtStreetandCity_10' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_10' name='txtPhoneNumber_10' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_10' name='txtContectPerson_10' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_10' name='txtDateApplied_10' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_10' name='txtNotes_10' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>11. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_11' name='txtCompany_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_11' name='txtPosition_11' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_11' name='txtStreetandCity_11' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_11' name='txtPhoneNumber_11' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_11' name='txtContectPerson_11' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_11' name='txtDateApplied_11' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_11' name='txtNotes_11' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>12. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_12' name='txtCompany_12' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_12' name='txtPosition_12' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_12' name='txtStreetandCity_12' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_12' name='txtPhoneNumber_12' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_12' name='txtContectPerson_12' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_12' name='txtDateApplied_12' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_12' name='txtNotes_12' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>13. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_13' name='txtCompany_13' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_13' name='txtPosition_13' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_13' name='txtStreetandCity_13' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_13' name='txtPhoneNumber_13' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_13' name='txtContectPerson_13' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_13' name='txtDateApplied_13' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_13' name='txtNotes_13' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>14. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_14' name='txtCompany_14' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_14' name='txtPosition_14' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_14' name='txtStreetandCity_14' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_14' name='txtPhoneNumber_14' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_14' name='txtContectPerson_14' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_14' name='txtDateApplied_14' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_14' name='txtNotes_14' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>15. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_15' name='txtCompany_15' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_15' name='txtPosition_15' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_15' name='txtStreetandCity_15' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_15' name='txtPhoneNumber_15' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_15' name='txtContectPerson_15' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_15' name='txtDateApplied_15' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_15' name='txtNotes_15' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>16. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_16' name='txtCompany_16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_16' name='txtPosition_16' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_16' name='txtStreetandCity_16' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_16' name='txtPhoneNumber_16' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_16' name='txtContectPerson_16' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_16' name='txtDateApplied_16' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_16' name='txtNotes_16' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>17. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_17' name='txtCompany_17' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_17' name='txtPosition_17' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_17' name='txtStreetandCity_17' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_17' name='txtPhoneNumber_17' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_17' name='txtContectPerson_17' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_17' name='txtDateApplied_17' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_17' name='txtNotes_17' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>18. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_18' name='txtCompany_18' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_18' name='txtPosition_18' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_18' name='txtStreetandCity_18' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_18' name='txtPhoneNumber_18' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_18' name='txtContectPerson_18' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_18' name='txtDateApplied_18' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_18' name='txtNotes_18' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>19. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_19' name='txtCompany_19' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_19' name='txtPosition_19' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_19' name='txtStreetandCity_19' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_19' name='txtPhoneNumber_19' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_19' name='txtContectPerson_19' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_19' name='txtDateApplied_19' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_19' name='txtNotes_19' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>20. Name of Company </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtCompany_20' name='txtCompany_20' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Position </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Street and City </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Phone Number </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Contect Person </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date Applied </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='text' id='txtPosition_20' name='txtPosition_20' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtStreetandCity_20' name='txtStreetandCity_20' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtPhoneNumber_20' name='txtPhoneNumber_20' className='add-only' /> </td>
                        <td className='w-150'><input type='text' id='txtContectPerson_20' name='txtContectPerson_20' className='add-only' /> </td>
                        <td className='w-150'><input type='date' id='txtDateApplied_20' name='txtDateApplied_20' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Notes:</span>
                    <textarea id='txtNotes_20' name='txtNotes_20' className='add-only'></textarea>
                </p>


                <p className='w-750'><br />
                    <center><span className='eleHeader'>Thank you letter sample</span></center>
                    June 23, 2020 <br /> <br />
                    Dear Ms. Scott, <br />
                    Thank you for taking the time to interview me today for the Busser position at Village Corner Bakery and Tavern.  I enjoyed learning more about the company and details of the job.  Our conversation confirmed my interest in working there as well as my ability to exceed expectations and grow with the company.
                    I look forward to the opportunity to become a part of your team and to speaking with you again soon.  Please do not hesitate to contact me if you have any questions or need additional information at 000-000-0000. <br />
                    Sincerely,<br />
                    <br />
                    Barney Rubble<br />
                    <hr></hr>
                    <br />
                    <center><span className='eleHeader'>Two Weeks notice sample</span></center>
                    January 23, 2020<br /> <br />
                    Dear Human Resources/Supervisor,<br />
                    Please accept this as my two weeks' notice to resign from my part-time cleaning position with ABM at the Atlanta airport.  This was not an easy decision to make.  I have enjoyed working with a successful and dedicated team.  I appreciate the friendships and opportunity for growth.  My last day of work will need to be on February 6, 2020.  If I can be of any help during this transition, please do not hesitate to ask.<br />
                    Sincerely,<br />
                    <br />
                    Fred Flintstone<br />
                    <br />

                    <center><span className='eleHeader'>Sample Cover Letter</span></center>
                    6/26/2020 <br /> <br />
                    To Whom It May Concern:<br />
                    I learned about the Scheduling Coordinator position on Indeed and feel I am very qualified for the position. I have years of experience working in hospitals and doctor offices where I have worked as an OR Scheduler, MRI and X-ray scheduler. I work very well with patients/families, doctors and all medical staff. I am thorough in my work and am confident I will be a great fit at Cherokee Imaging Center. Please do not hesitate to call me if you have any questions or to schedule an immediate interview. 864-396-0940. I look forward to speaking with you soon. Thank you.<br />
                    Sincerely,<br />
                    <br />
                    Betty Rubble
                </p>






            </div>
        </form>

    )
}